(function () {
  'use strict';

  angular
    .module('app.preloader', []);
})();
